export const quizCases = 
[
    [
        { text: "People living with HIV can work in any organisation. We should support our positive colleagues and not stigmatise them.", correct: true },
        { text: "People assume that all people who work in HIV/AIDS related organizations are infected." }
    ],
    [
        { text: "If you are HIV positive, your partner also has  HIV." },
        { text: "Undetectable=Untransmittable. Those who are HIV positive but are taking their ART medication and have an undetectable viral load cannot pass it on to their partner", correct: true }
    ],
    [
        { text: "You lower the risk of contracting  HIV if you wash/bathe immediately after sex. " },
        { text: "ART adherence (PREP) for the HIV negative partners can prevent them from becoming infected. ", correct: true }
    ],
    [
        { text: "There is no cure for AIDS. Herbal remedies (dawa) can help with some of the side effects of the pharmaceutical drug treatments.", correct: true },
        { text: "In the 80’s and early 90’s herbalists could cure AIDS. " },
        
    ],
    [
        { text: "Some pastors have prayed and cured HIV." },
        { text: "HIV and AIDS can only be treated medically. There has never been a case whereby a pastor has cured AIDS or performed a miracle that has freed anyone from HIV.", correct: true }
    ],
    [
        { text: "HIV tests are between 99% and 100% reliable. Paying doctors for fake test results is harmful to both you and your sexual partners.", correct: true },
        { text: "Some foods or natural remedies can change the results of an HIV test." }
        
    ],
    [
        { text: "An HIV positive mother can give birth to an HIV negative baby if she takes the correct precautions and medications.", correct: true },
        { text: "HIV positive pregnant women give birth to HIV positive babies" }
        
    ],
    [
        { text: "You can tell someone is HIV positive by looking at them" },
        { text: "People living with HIV can look as healthy as any other person and even have no visible signs of the virus.", correct: true }
    ],
    [
        { text: "If you are HIV positive, your partner will always have HIV" },
        { text: "One partner can be HIV positive and one HIV negative. This is known as discordance.", correct: true }
    ],
    [
        { text: "There is a cure for HIV and a vaccine and the drug companies are preventing people from getting them." },
        { text: "There is no vaccine against HIV. Scientists have tried to find different cures and vaccines for HIV but to date this does not exist. Hoping for a cure is not a reason to avoid testing or taking treatment.", correct: true }
    ],
    [
        { text: "HIV and AIDS are different things. HIV is the virus you contract and become HIV positive. AIDS is the acquired immune deficiency syndrome that results from HIV.", correct: true },
        { text: "HIV/AIDS is one term for the same thing" }
        
    ]
]
